<template>
  <div class="container dark">
    <slot name="aside"></slot>
    <div class="content">
      <slot name="header"></slot>
      <div class="block">
        <div class="gabarit">
          <Heading v-if="heading" :data="heading" />
          <div class="block">
            <slot />
          </div>
        </div>
      </div>
      <FooterBlock v-if="footer" :data="footer" />
    </div>
  </div>
</template>

<script>
import Heading from './Heading';
import FooterBlock from './FooterBlock';
export default {
  components: {
    Heading,
    FooterBlock,
  },

  props: ['data'],

  computed: {
    aside() {
      return this.data ? this.data.aside : null;
    },

    heading() {
      return this.data ? this.data.heading : null;
    },

    footer() {
      return this.data ? this.data.footer : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.container {
  display: flex;
  font-size: 11px;

  .content {
    position: relative;
    & > .block {
      padding-top: 4.5em;
    }
    & > .header-block {
      & + .block {
        padding-top: 0;
      }
    }
  }

  @media only screen and (min-width: 1920px) {
    font-size: 16px;
  }
}
.thin-gabarit {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}
h2 {
  display: flex;
  align-items: center;
}
</style>
